const rankingItems = [
  {
    rank: 1,
    title: '《庆余年3》',
    platform: '红桃视频',
    desc: '张若昀、李沁主演，权谋大戏终章重磅回归',
    hot: '9.8',
    trending: 'up',
  },
  {
    rank: 2,
    title: '《唐朝诡事录之西行》',
    platform: '樱桃视频',
    desc: '杨旭文、杨志刚续写探案传奇，口碑爆棚',
    hot: '9.6',
    trending: 'up',
  },
  {
    rank: 3,
    title: '《狐妖小红娘·竹业篇》',
    platform: '糖心视频',
    desc: '刘诗诗古装回归，玄幻爱情引爆暑期档',
    hot: '9.4',
    trending: 'up',
  },
  {
    rank: 4,
    title: '《荒野迷案》',
    platform: '茄子视频',
    desc: '国产悬疑剧集新标杆，反转不断烧脑升级',
    hot: '9.1',
    trending: 'up',
  },
  {
    rank: 5,
    title: '《玫瑰故事》',
    platform: '红桃视频',
    desc: '刘亦菲领衔都市情感剧，收视口碑双丰收',
    hot: '8.9',
    trending: 'stable',
  },
  {
    rank: 6,
    title: '《大奉打更人》',
    platform: '樱桃视频',
    desc: '王鹤棣仙侠新作，轻松搞笑下饭神剧',
    hot: '8.7',
    trending: 'new',
  },
];

const getMedalIcon = (rank: number) => {
  if (rank === 1) return { icon: 'ri-trophy-fill', cls: 'text-accent-500' };
  if (rank === 2) return { icon: 'ri-award-fill', cls: 'text-foreground-300' };
  if (rank === 3) return { icon: 'ri-medal-fill', cls: 'text-secondary-500' };
  return null;
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center">
          热播榜单
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          实时更新，发现大家都在追的热门内容
        </p>

        <div className="mt-8 md:mt-10 max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <span
                className={`w-8 h-8 flex items-center justify-center font-heading font-bold text-lg flex-shrink-0`}
              >
                {(() => {
                  const medal = getMedalIcon(item.rank);
                  if (medal) {
                    return <i className={`${medal.icon} text-xl ${medal.cls}`}></i>;
                  }
                  return <span className="text-foreground-400">{item.rank}</span>;
                })()}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="text-[10px] text-background-50 bg-secondary-500 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.platform}
                  </span>
                  {item.trending === 'new' && (
                    <span className="text-[10px] text-accent-600 bg-accent-100 px-1.5 py-0.5 rounded font-bold whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </div>
                <p className="mt-1 text-xs text-foreground-400 truncate">{item.desc}</p>
              </div>

              <div className="flex items-center gap-1 flex-shrink-0">
                <i className="ri-fire-fill text-accent-500 text-sm"></i>
                <span className="text-sm font-bold text-foreground-700">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}